import '../../styles/Spinner.css' 
import Title from '../Title/Title'

export default function Spinner() {

    return(
      <div>
        <Title text={"Carregando"}/> 
     <div className="spinner-container">

      <div className="spinner"></div> 
    </div>
    </div>
)
}